import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { getRemarkType } from '../helpers/getRemarkType';
import { selectUserId, selectWork,selectWorks } from '../../../Api/selectors';

import { performAction, refreshBoards } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { List, Row, Cell } from '../../../../components/List';

import { Cell as ActionCell } from '../Cell';
import { formatCurrency } from '../../../../utils/string';
import { updateInvoiceStatus } from '../../../Invoices/actions';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import { setVehicleProperty } from '../../../Vehicles/actions';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './ADM_NL_IDW.module.css';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';

const TASK_REMARK_TYPE = 'Inkoop_vrijwaren';


const Container = styled.div`
  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
};

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

/* eslint-disable react/prefer-stateless-function */
class ADM_IN_3_purchase_releaseComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  onDelete() {
    this.props.setProperty(this.vehicle?.id, 'purchase_release_wait', '1', result => {
      if (result) {
        this.reset();
      }
    });
  }

  onReleaseManual() {
    this.props.setProperty(this.vehicle?.id, 'purchase_release_manual', '1', result => {
      if (result) {
        this.reset();
      }
    });
  }

  render01(name) {
    return (
      <Checkbox
        key={name}
        checked={this.state[name] == TASK_STATUS_ACTIVE}
        onChange={() => {
          this.setState({ [name]: this.state[name] != TASK_STATUS_ACTIVE ? TASK_STATUS_ACTIVE : TASK_STATUS_INACTIVE });
        }}
      >
        {this.lbl(`vehicle.property.${name}`)}
      </Checkbox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        {this.renderModalBody()}
      </ModalComponent>
    );
  }

  renderModalBody() {
    if (this.state.loading) return <Loader />;
    console.log(this.vehicle.outgoing_invoice);
    return (
      <WithVehicle vehicle_id={this.vehicle.id} loader>
        <VehicleHeader vehicle={this.vehicle} />
        {/* <div className="pane"></div> */}
        {this.vehicle.outgoing_invoice ? (
          <VBox center>
            <Row className={styles.rowContainer}>
              <Cell>{this.lbl(`vehicle.property.invoice_outgoing_company_id`)}</Cell>
              <Cell>
                <CompanyLabelById company_id={this.vehicle.invoice_outgoing_company_id} />
              </Cell>
            </Row>

            <Row>
              <ButtonComponent
                style={'ButtonSoftPrimary'}
                onClick={this.tofn(`/companies/${this.vehicle.invoice_outgoing_company_id}`)}
              >
                <View /> {this.lbl('vehicle.details.supplier.company.opencompany')}
              </ButtonComponent>
            </Row>
          </VBox>
        ) : null}

        <div className="d-flex gap-2 flex-wrap mt-2">
          <PerformActionButton
            className={styles.confirmButton}
            name={this.lbl('vehicle.kanban.wait_for_purchase_release')}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.onDelete.bind(this)}
          />
          <PerformActionButton
            className={styles.confirmButton}
            name={this.lbl('vehicle.kanban.allready_released')}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.onReleaseManual.bind(this)}
          />
          <PerformActionButton
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </WithVehicle>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <Label count={vehicle?.inkoopadministratie} ranges={ranges}>
            {vehicle?.inkoopadministratie || '0'}

          </Label>
           <CellButtons>
                   {this.props.cell.busy ? (
                       <Loader small />
                     ) : (
                       <>
                         {this.props.workRemarks ? (
                           <Loader small />
                         ) : (
                           <KanbanVehicleRemarks
                             readOnly
                             taskName={TASK_REMARK_TYPE}
                             kanbanBoardLabel={this.props.board?.label}
                             vehicleId={this.vehicle.id}
                             loggedUserId={this.props.loggedInUserId}
                           />
                         )}
                                         <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
         
                           <View />
                         </CellButton>
                       </>
                     )}
                   </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }
}

ADM_IN_3_purchase_releaseComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
        workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
    loggedInUserId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    invoicePaid(invoiceId, callback) {
      dispatch(updateInvoiceStatus(invoiceId, 2, callback));
    },
    setProperty(vehicleId, name, value, callback) {
      dispatch(setVehicleProperty(vehicleId, name, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ADM_IN_3_purchase_release = compose(withConnect, withRouter)(ADM_IN_3_purchase_releaseComp);
